<div class="flex align-center-center">
    <mat-icon class="mr-2">{{ this.icon }}</mat-icon>{{ this.message }}
</div>
